// extracted by mini-css-extract-plugin
export default {"boss-name":"Boss_boss-name__9OwQL","boss-img":"Boss_boss-img__ae7Ba","boss-health-color":"Boss_boss-health-color__aIzW4","boss-health-value":"Boss_boss-health-value__wrS4l"};